import * as React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { UserInfo } from '../../../User/UserTypes';
import UserRow from '../../../User/UserRow';
import InteractableSurface from '../../../Surface/InteractableSurface';
import {
  MenuItemsRenderer,
  MenuItemType
} from '../../../Workspace/subComponents/MenuItemsRenderer';
import { EllipsisMenu } from '@cube3/cubicle/src/core/molecules/EllipsisMenu';
import { MenuEntry } from '@cube3/cubicle/src/core/molecules/ContextMenu/NestedMenu';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      height: theme.sizing[56]
    }
  })
);

interface Properties {
  userInfo: UserInfo;
  onResendLinkClick: (info: UserInfo) => void;
  onRemoveAccessClick: (info: UserInfo) => void;
  isAuth?: boolean;
}

const ManageAccessUserDetail: React.FC<Properties> = (props) => {
  const { userInfo, onResendLinkClick, onRemoveAccessClick, isAuth } = props;

  const menuItems = React.useMemo(
    () => [
      {
        entries: [
          isAuth
            ? null
            : {
                title: 'Resend personal link',
                onClick: () => {
                  onResendLinkClick(userInfo);
                }
              },
          {
            title: 'Remove access',
            onClick: () => {
              onRemoveAccessClick(userInfo);
            }
          }
        ].filter(Boolean) as MenuEntry[]
      }
    ],
    [isAuth, onRemoveAccessClick, onResendLinkClick, userInfo]
  );

  const classes = useStyles();

  return (
    <InteractableSurface
      highlightOnHover={true}
      surfaceProps={{ corners: 'rounded' }}
      classes={{ root: classes.root }}
    >
      <UserRow userInfo={userInfo} />
      <EllipsisMenu menu={menuItems} />
    </InteractableSurface>
  );
};
/**
 * @summary Shows info about a `User` and provides the ability to reshare a link or delete a user from a link.
 */
export default ManageAccessUserDetail;
